import { AppLanguage } from '~/types/locale'

export const getMultiChampGameLogo = (lang: string | undefined): string => {
  switch (lang) {
    case AppLanguage.NO:
      return 'logos/multi-champ-no.png'
    case AppLanguage.UA:
      return 'logos/multi-champ-ua.png'
    default:
      return 'logos/multi-champ-en.png'
  }
}
